import { Store } from 'src/store/index';
import dpiWarningsExists from 'src/util/design/dpiWarningsExists';
import getIsAgreeWithLowDPI from './getIsAgreeWithLowDPI';
import getStructure from './getStructure';

const shouldDisplayLowDPIWarning = (store: Store) => (
  dpiWarningsExists(getStructure(store)) && !getIsAgreeWithLowDPI(store));

export default shouldDisplayLowDPIWarning;
